export default __webpack_public_path__ + "static/media/headline.0ee27b28.png";